import React,{Component} from 'react';
import axios from 'axios';
import { APIURL } from '../../../config/config';
import NumberFormat from 'react-number-format';

class CarLeasingView extends Component {
  constructor (props){
    super(props)
    this.state = {
      lists: [],
      car_id : this.props.car.car_id,
      leasingName: ['SCB', 'GE', 'TA', 'KK', 'BA']
    }
  }

  componentDidMount() {
    this.loadCarLeasing();
  }

  componentWillReceiveProps(nextProps) {

    // console.log('componentWillReceiveProps CarLeasingView')
    // console.log(this.props.car.car_id+ ' => ' +this.nextProps.car.car_id)
    // console.log(this.props.carLeasingList)
    // console.log(nextProps.carLeasingList)

    // if(nextProps.carLeasingList.length ===0 && this.props.carLeasingList.length === 0 ){
      // this.setState({lists: []});
      // this.loadCarLeasing();
    // }

    /*if(nextProps.carLeasingList !== this.props.carLeasingList) {
      //if (nextProps.carLeasingList.length > 0 && this.state.lists.length === 0) {
      if (nextProps.carLeasingList.length > 0 ) {
        var next_car_id = nextProps.carLeasingList[0].car_id ;
        if(next_car_id!==this.state.car_id){
          this.setState({
            lists: []
          });
        }else{
          this.setState({
            lists: nextProps.carLeasingList
          },()=>{
            // this.loadCarLeasing();
          })
        }

      }
    }*/

     if(nextProps.carLeasingList.length > 0){
       //console.log('===nextProps car_id=' + nextProps.car.car_id)
        if(nextProps.carLeasingList[0].car_id === nextProps.car.car_id){
          this.setState({lists: nextProps.carLeasingList});
        }
     }

      if(nextProps.car !== this.props.car) {
      this.setState({
        car_id: nextProps.car.car_id
      },()=>{
        this.loadCarLeasing();
      });

    }

  }

  loadCarLeasing() {
    //console.log('===loadCarLeasing car_id=' + this.state.car_id)
    var uri =  APIURL + '/car_leasing/'+this.state.car_id;
    axios.get(uri)
      .then(res => {
        this.setState({lists: res.data})
      }).catch(error => {
      this.setState({lists: []})
    })
  }

  render(){
    if(this.state.lists.length === 0){
      let trLeasing = this.state.leasingName.map((leasing, index) => {
        return (
          <tr key={index}>
            <td style={{width: 100}}>{leasing}</td>
            <td style={{width: 100}}>&nbsp;-&nbsp;</td>
            <td style={{width: 100}}>&nbsp;-&nbsp;</td>
            <td style={{width: 100}}>&nbsp;-&nbsp;</td>
          </tr>
        )
      })
      return (
        <div>
          <table className="tableWhitesmoke" style={{marginTop: 8}}>
            <tbody>
             {trLeasing}
            </tbody>
          </table>
        </div>
      )
    }else {
      let trLeasing = this.state.lists.map((leasing, index) => {
        //if(leasing.car_leasing_name!=='MPRICE') {
          return (
            <tr key={index}>
              <td style={{width: 100}}>{leasing.car_leasing_name}</td>
              <td style={{width: 100}}>
                <NumberFormat
                  value={leasing.car_leasing_price_median} displayType={'text'} thousandSeparator={true}
                  prefix={'฿'}/>
              </td>
              <td style={{width: 100}}>
                <NumberFormat
                  value={leasing.car_leasing_price} displayType={'text'} thousandSeparator={true}
                  prefix={'฿'}/>
              </td>
              <td style={{width: 100}}>
                <NumberFormat
                  value={leasing.car_leasing_price_nc} displayType={'text'} thousandSeparator={true}
                  prefix={'฿'}/>
              </td>
            </tr>
          )
        //}else{
          /*return (
          <tr key={index}>
            <td style={{width: 100}}>ราคากลาง</td>
            <td colSpan={2} style={{width: 200}} className="text-center">
              <NumberFormat
                value={leasing.car_leasing_price} displayType={'text'} thousandSeparator={true}
                prefix={'฿'}/>
            </td>
          </tr>
          )*/
        //}
      })

      return (
        <div>
          <table className="tableWhitesmoke" style={{marginTop: 8}}>
            <thead>
              <tr>
              <th>ธนาคาร</th>
              <th>ราคากลาง</th>
              <th>เครดิต</th>
              <th>ไม่เครดิต</th>
              </tr>
            </thead>
            <tbody>
            {trLeasing}
            </tbody>
          </table>
        </div>
      )
    }
  }
}

/*const styles = {
  tableLeasing: {
    backgroundColor: 'tableWhitesmoke'
  }
}*/

export default CarLeasingView ;